/* NC MILLTEK BRANDSIDE – hurtigvalg styrer Typesense-filtrene (window.ncTsSearch sættes af typesense-search-brands-v9.js).
   Knapper: [data-nc-attr][data-nc-value] eller [data-nc-q]  (+ data-nc-group="lyd"|"bil" = kun ét valg i gruppen, data-nc-scroll = rul op til varelisten).
   Uden JS (eller hvis søgningen ikke svarer) er knapperne almindelige links med filter i adressen. */
(function () {
  var search = null;

  function refined(st, a, v) {
    return st.isFacetRefined(a, v) || (st.isDisjunctiveFacetRefined && st.isDisjunctiveFacetRefined(a, v));
  }
  function values(st, a) {
    return (st.facetsRefinements[a] || []).concat(st.disjunctiveFacetsRefinements[a] || []);
  }
  function sync() {
    if (!search || !search.helper) return;
    var st = search.helper.state;
    document.querySelectorAll('[data-nc-attr]').forEach(function (b) {
      b.setAttribute('aria-pressed', refined(st, b.getAttribute('data-nc-attr'), b.getAttribute('data-nc-value')) ? 'true' : 'false');
    });
    document.querySelectorAll('[data-nc-q]').forEach(function (b) {
      b.setAttribute('aria-pressed', (st.query || '') === b.getAttribute('data-nc-q') ? 'true' : 'false');
    });
  }
  function scrollToList() {
    var el = document.getElementById('nc-collection-toolbar') || document.getElementById('typesense-collection-root');
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-nc-open-filters]');
    if (open) {
      var t = document.querySelector('[data-ts-filter-toggle]');
      if (t) { e.preventDefault(); t.click(); scrollToList(); }
      return;
    }
    var qb = e.target.closest('[data-nc-q]'); // fritekstsøgning, fx bilmærke; klik igen nulstiller
    if (qb && search && search.helper) {
      e.preventDefault();
      var q = qb.getAttribute('data-nc-q');
      search.helper.setQuery((search.helper.state.query || '') === q ? '' : q).search();
      if (qb.hasAttribute('data-nc-scroll')) scrollToList();
      return;
    }
    var b = e.target.closest('[data-nc-attr]');
    if (!b || !search || !search.helper) return; // uden søgning: lad linket virke
    e.preventDefault();
    var a = b.getAttribute('data-nc-attr'), v = b.getAttribute('data-nc-value'), g = b.getAttribute('data-nc-group');
    var h = search.helper;
    if (g) {
      values(h.state, a).forEach(function (x) {
        if (x !== v && x.indexOf(g + ':') === 0) h.toggleFacetRefinement(a, x);
      });
    }
    h.toggleFacetRefinement(a, v).search();
    if (b.hasAttribute('data-nc-scroll')) scrollToList();
  });

  // Modeltoppens introtekst står på én linje. Kan den ikke vises helt, skjules den (aldrig en halv sætning med …).
  function fitIntro() {
    document.querySelectorAll('.nc-model-head .nc-mc-head__text p').forEach(function (p) {
      p.hidden = false;
      if (p.offsetParent === null) return; // skjult af CSS (mobil)
      p.hidden = p.scrollWidth > p.clientWidth + 1;
    });
  }
  fitIntro();
  window.addEventListener('resize', fitIntro);
  window.addEventListener('load', fitIntro);

  // Live-validering: hvert hurtigvalg (data-nc-attr) tælles i kollektionens scope med én multi_search;
  // valg uden varer skjules (og gruppen, hvis den bliver tom). Fejler kaldet, vises alt som før.
  // Grupper med data-nc-facet (modelsiden) får desuden alle facettens øvrige værdier med varer tilføjet.
  function pruneChips() {
    var cfg = window.nardoSearch || {};
    var chips = [].slice.call(document.querySelectorAll('.nc-mc-head [data-nc-attr][data-nc-value]'));
    var groups = [].slice.call(document.querySelectorAll('.nc-mc-head [data-nc-facet]'));
    if ((!chips.length && !groups.length) || !cfg.host || !cfg.searchKey || !cfg.collection) return;
    var q = function (v) { return '`' + String(v).replace(/`/g, '') + '`'; };
    var scope = 'visibility:=' + q('all');
    if (cfg.collectionFilter) scope += ' && (' + cfg.collectionFilter + ')';
    else if (cfg.collectionId) scope += ' && collection_ids:=[' + q(cfg.collectionId) + ']';
    var searches = chips.map(function (c) {
      return { collection: cfg.collection, q: '*', per_page: 0,
        filter_by: scope + ' && ' + c.getAttribute('data-nc-attr') + ':=[' + q(c.getAttribute('data-nc-value')) + ']' };
    });
    groups.forEach(function (g) {
      searches.push({ collection: cfg.collection, q: '*', per_page: 0, filter_by: scope,
        facet_by: g.getAttribute('data-nc-facet'), max_facet_values: 100 });
    });
    fetch((cfg.protocol || 'https') + '://' + cfg.host + '/multi_search', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-TYPESENSE-API-KEY': cfg.searchKey },
      body: JSON.stringify({ searches: searches })
    }).then(function (r) { return r.json(); }).then(function (d) {
      (d.results || []).forEach(function (res, i) {
        if (i >= chips.length) return addFacetChips(groups[i - chips.length], res);
        if (res && typeof res.found === 'number' && res.found === 0) { chips[i].hidden = true; chips[i].setAttribute('data-nc-dead', ''); }
      });
      fitChips();
      sync();
    }).catch(function () {});
  }
  function addFacetChips(g, res) {
    var attr = g.getAttribute('data-nc-facet');
    var fc = ((res && res.facet_counts) || []).filter(function (f) { return f.field_name === attr; })[0];
    if (!fc) return;
    var have = {};
    g.querySelectorAll('[data-nc-value]').forEach(function (c) { have[c.getAttribute('data-nc-value')] = true; });
    fc.counts.forEach(function (x) {
      if (!x.count || have[x.value]) return;
      var a = document.createElement('a');
      a.setAttribute('role', 'button');
      a.className = 'nc-mc-chip';
      a.href = '?' + attr + '=' + encodeURIComponent(x.value);
      a.setAttribute('data-nc-attr', attr);
      a.setAttribute('data-nc-value', x.value);
      a.setAttribute('data-nc-group', 'kategori');
      a.setAttribute('aria-pressed', 'false');
      a.textContent = x.value;
      g.appendChild(a);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruneChips);
  else pruneChips();

  // Hurtigvalg der ikke kan vises helt i rækken, fjernes (ingen halve knapper, ingen vandret rul). Genberegnes ved resize.
  function fitChips() {
    document.querySelectorAll('.nc-mc-head .nc-mc-chips').forEach(function (row) {
      var chips = [].slice.call(row.querySelectorAll('.nc-mc-chip'));
      chips.forEach(function (c) { if (!c.hasAttribute('data-nc-dead')) c.hidden = false; });
      var limit = row.getBoundingClientRect().right - parseFloat(getComputedStyle(row).paddingRight || 0);
      chips.forEach(function (c) {
        if (!c.hidden && c.getBoundingClientRect().right > limit + 0.5) c.hidden = true;
      });
      row.querySelectorAll('.nc-mc-group').forEach(function (g) {
        g.hidden = !g.querySelector('.nc-mc-chip:not([hidden])');
      });
    });
  }
  fitChips();
  window.addEventListener('resize', fitChips);
  window.addEventListener('load', fitChips);

  var tries = 0;
  (function wait() {
    if (window.ncTsSearch && window.ncTsSearch.helper) {
      search = window.ncTsSearch;
      search.on('render', sync);
      sync();
      return;
    }
    if (++tries < 80) window.setTimeout(wait, 150);
  })();
})();
